import MyFlex from './MyFlex';

const MyFlexCenter = ({ children, ...otherProps }) => {
  return (
    <MyFlex align="center" justify="center" {...otherProps}>
      {children}
    </MyFlex>
  );
};

export default MyFlexCenter;
